import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { ICrudGetAction } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IRootState } from 'app/shared/reducers';
import { getEntity } from './application-configuration.reducer';
import { IApplicationConfiguration } from 'app/shared/model/application-configuration.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';

export interface IApplicationConfigurationDetailProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> {}

export const ApplicationConfigurationDetail = (props: IApplicationConfigurationDetailProps) => {
  useEffect(() => {
    props.getEntity(props.match.params.id);
  }, []);

  const { applicationConfigurationEntity } = props;
  return (
    <Row>
      <Col md="8">
        <h2>
          ApplicationConfiguration [<b>{applicationConfigurationEntity.id}</b>]
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="configurationName">Configuration Name</span>
          </dt>
          <dd>{applicationConfigurationEntity.configurationName}</dd>
          <dt>
            <span id="configurationValue">Configuration Value</span>
          </dt>
          <dd>{applicationConfigurationEntity.configurationValue}</dd>
        </dl>
        <Button tag={Link} to="/application-configuration" replace color="info">
          <FontAwesomeIcon icon="arrow-left" /> <span className="d-none d-md-inline">Back</span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/application-configuration/${applicationConfigurationEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">Edit</span>
        </Button>
      </Col>
    </Row>
  );
};

const mapStateToProps = ({ applicationConfiguration }: IRootState) => ({
  applicationConfigurationEntity: applicationConfiguration.entity,
});

const mapDispatchToProps = { getEntity };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(ApplicationConfigurationDetail);
